import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class GridValidationFactoryService {
  validate(data: any, rules: any): { valid: boolean; errors: string[] } {
    const errors: string[] = [];

    if (!rules || !data) {
      return { valid: true, errors };
    }

    _.forEach(rules, (rule: any) => {
      const value = data[rule.field];
      if (rule.required && (value === null || value === undefined || value === '')) {
        errors.push(`${rule.field} is required`);
      }
      if (rule.maxLength && value && value.length > rule.maxLength) {
        errors.push(`${rule.field} exceeds max length of ${rule.maxLength}`);
      }
      if (rule.pattern && value && !new RegExp(rule.pattern).test(value)) {
        errors.push(`${rule.field} does not match expected pattern`);
      }
    });

    return { valid: errors.length === 0, errors };
  }
}
